import { MockedRequest, RestHandler, rest } from "msw";

import { MOCK_SIGNED_URL } from "mocks/fixtures/sessionFixtures";

export const uploadPhotoHandler = (
  status: number,
  response: {} | null,
  once = false
): RestHandler<MockedRequest<{} | null>> => {
  return rest.put(MOCK_SIGNED_URL, (_req, res, ctx) => {
    if (once) return res.once(ctx.status(status), ctx.json(response));

    return res(ctx.status(status), ctx.json(response));
  });
};

export const uploadHandlers = [uploadPhotoHandler(200, {})];
